import { Component, OnInit, HostListener } from '@angular/core';
import { File } from './../../models/files/files.model';
import { ActivatedRoute, Router } from '@angular/router';

import * as appConfig from './../../app.config';
import { ApiService } from './../../shared/services/api.service';

@Component({
  selector: 'swb-file-zoom',
  templateUrl: './file-zoom.component.html',
  styleUrls: ['./file-zoom.component.scss']
})
export class FileZoomComponent implements OnInit {
  private _image: File;
  private _id: string;

  @HostListener('document:keyup', ['$event'])

  onKeyUp(ev: KeyboardEvent) {
    switch (ev.key) {
      case 'Escape':
        this.closeModal(ev);
        break;
      default:
        break;
    }
  }

  constructor(
    private _apiService: ApiService,
    private _route: ActivatedRoute,
    private _router: Router
  ) { }

  ngOnInit() {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    if (this._id) {
      this._getImage('files', this._id);
    }
  }

  public getStyle(): any {

    if (this._image && this._image.is_image) {
      return {
        'background-image': 'url(' + appConfig.apiUrl + appConfig.mediaFolder + this._image.file_fullname + ')'
      };
    }

    return {};
  }

  public closeModal($event: any): void {

    this._router.navigate([{ outlets: { modal: null }, event: $event }], {
      relativeTo: this._route.parent
    });

  }

  private _getImage(uri: string, id: string): void {
    this._apiService.get(uri + '/' + id)
      .subscribe(
      (response: any) => {
        this._image = { ...response }.data;
      },
      (error) => console.error(error)
      );
  }

}
